import React from "react";
import "./message.css";

function Message({msg}) {

    setTimeout(() => {
        document.querySelector('.message-container').style.display="flex"
    }, 3000);
    
    return (
        <div className="message">
            {msg}
        </div>
    );
}

export default Message;
